import LearnPageLayout from "@/components/LearnPageLayout";
import { pageFastTrd } from "./learnDataFastTrd";

const FastTrdPage = () => (
  <LearnPageLayout
    title={pageFastTrd.title}
    description={pageFastTrd.description}
    canonical={pageFastTrd.canonical}
    h1={pageFastTrd.h1}
    breadcrumbLabel={pageFastTrd.breadcrumbLabel}
    crumbs={pageFastTrd.crumbs}
    shortAnswer={pageFastTrd.shortAnswer}
    keyTakeaways={pageFastTrd.keyTakeaways}
    sections={pageFastTrd.sections}
    faqs={pageFastTrd.faqs}
    sources={pageFastTrd.sources}
    schemaJson={pageFastTrd.schemaJson}
    relatedLinks={pageFastTrd.relatedLinks}
    reviewBlock={pageFastTrd.reviewBlock}
  />
);

export default FastTrdPage;
